<template>
  <section class="featured-products position-relative see__pad">
    <div class="pattern-layer">
      <div
        class="pattern-9 position-absolute"
        style="background-image: url('/shapes/shape-07.png')"
      ></div>
    </div>
    <div class="pattern-layer">
      <div
        class="pattern-10 position-absolute"
        style="background-image: url('/shapes/shape-08.png')"
      ></div>
    </div>
    <div class="pattern-layer">
      <div
        class="pattern-11 position-absolute"
        style="background-image: url('/shapes/shape-09.png')"
      ></div>
    </div>
    <div class="pattern-layer">
      <div
        class="pattern-12 position-absolute"
        style="background-image: url('/shapes/shape-10.png')"
      ></div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="products-header text-center">
            <div class="products-section-label">
              <h4>{{ content.sectionLabel }}</h4>
            </div>
            <div class="products-main-title">
              <h2>
                {{ content.sectionTitle }} <span>{{ content.sectionTitleHighlight }}</span>
              </h2>
            </div>
          </div>
        </div>
      </div>

      <div class="products-grid">
        <div 
          class="product-item"
          v-for="(product, index) in content.products"
          :key="index"
        >
          <div class="product-image">
            <img
              :src="product.image"
              :alt="product.title"
            />
            <div class="product-overlay">
              <div class="product-tech-stack">
                <span 
                  class="tech-tag"
                  v-for="(tech, techIndex) in product.techStack"
                  :key="techIndex"
                >
                  {{ tech }}
                </span>
              </div>
            </div>
          </div>
          <div class="product-content">
            <h3>{{ product.title }}</h3>
            <p>{{ product.description }}</p>
            
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "SynergyItsFeaturedComp",
  props: {
    content: {
      type: Object,
      required: true,
      default: () => ({
        sectionLabel: "Industry Showcases",
        sectionTitle: "10 Industry-wise",
        sectionTitleHighlight: "Software Product Showcases",
        products: [
          {
            title: "Healthcare",
            description: "Patient Management System, Remote Diagnostics, AI-powered Health Insights - comprehensive healthcare software solutions.",
            image: "/resource/portfolio-01.jpg",
            techStack: ["Vue.js", "Node.js", "MongoDB"],
            link: "/products/healthcare"
          },
          {
            title: "Fintech",
            description: "Digital Wallets, KYC Modules, Crypto Payment Gateway, Fraud Detection Systems - next-generation financial technology solutions.",
            image: "/resource/portfolio-02.jpg",
            techStack: ["React", "Python", "PostgreSQL"],
            link: "/products/fintech"
          },
          {
            title: "Education",
            description: "LMS Systems, Virtual Classrooms, AI-Powered Assessment Tools - comprehensive educational technology solutions.",
            image: "/resource/portfolio-03.jpg",
            techStack: ["Flutter", "Firebase", "AWS"],
            link: "/products/education"
          },
          {
            title: "Retail & E-commerce",
            description: "Multi-vendor Marketplace Platform, Order Tracking System, Loyalty Programs - comprehensive retail technology solutions.",
            image: "/resource/portfolio-04.jpg",
            techStack: ["Next.js", "Stripe", "Redis"],
            link: "/products/retail-ecommerce"
          },
          {
            title: "Logistics",
            description: "Real-Time Fleet Tracking, Inventory & Dispatch Tools - comprehensive logistics management solutions.",
            image: "/resource/portfolio-01.jpg",
            techStack: ["IoT", "GPS", "Analytics"],
            link: "/products/logistics"
          },
          {
            title: "Automotive",
            description: "Vehicle Booking System, Garage Management Software - comprehensive automotive technology solutions.",
            image: "/resource/portfolio-02.jpg",
            techStack: ["Booking", "Management", "IoT"],
            link: "/products/automotive"
          },
          {
            title: "AI & Automation",
            description: "Chatbots, Process Bots, NLP Engines - advanced artificial intelligence and automation solutions.",
            image: "/resource/portfolio-03.jpg",
            techStack: ["AI", "NLP", "ML"],
            link: "/products/ai-automation"
          },
          {
            title: "Manufacturing",
            description: "Smart Factory Dashboard, IoT Integration Suite - comprehensive manufacturing technology solutions.",
            image: "/resource/portfolio-04.jpg",
            techStack: ["IoT", "Dashboard", "Analytics"],
            link: "/products/manufacturing"
          },
          {
            title: "Real Estate",
            description: "Property Listing + CRM Software, Rent Management Apps - comprehensive real estate technology solutions.",
            image: "/resource/portfolio-01.jpg",
            techStack: ["CRM", "Mobile", "Analytics"],
            link: "/products/real-estate"
          },
          {
            title: "Market Research",
            description: "Survey Tools, Dashboards, Data Visualization Systems - comprehensive market research technology solutions.",
            image: "/resource/portfolio-02.jpg",
            techStack: ["Analytics", "Visualization", "Survey"],
            link: "/products/market-research"
          }
        ]
      })
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url("https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap");

/* Import Flaticon */
@import "@/assets/scss/Flaticon.scss";

.see__pad {
  padding: 100px 0;
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

/* Pattern Layers */
.pattern-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  pointer-events: none;
}

.pattern-9 {
  bottom: 25%;
  right: 20%;
  width: 70px;
  height: 70px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.pattern-10 {
  top: 40%;
  left: 5%;
  width: 110px;
  height: 110px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.09;
}

.pattern-11 {
  bottom: 15%;
  left: 12%;
  width: 85px;
  height: 85px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

.pattern-12 {
  top: 35%;
  right: 8%;
  width: 95px;
  height: 95px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

/* Featured Products Section */
.featured-products {
  background: #00061a;
  position: relative;
  overflow: hidden;
}

.products-header {
  margin-bottom: 60px;
}

.products-section-label h4 {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 13.2px;
  color: #f6ec4f;
  margin-bottom: 20px;
  font-family: "Archivo", sans-serif;
  text-transform: uppercase;
}

.products-main-title h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  margin-bottom: 0;
  font-family: "Archivo", sans-serif;
}

.products-main-title h2 span {
  color: #f6ec4f;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
  margin-top: 50px;
}

.product-item {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 15px;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid rgba(246, 236, 79, 0.1);
}

.product-item:hover {
  transform: translateY(-10px);
  border-color: #f6ec4f;
  background: rgba(255, 255, 255, 0.08);
}

.product-image {
  position: relative;
  overflow: hidden;
  height: 200px;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.product-item:hover .product-image img {
  transform: scale(1.1);
}

.product-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 6, 26, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.product-item:hover .product-overlay {
  opacity: 1;
}

.product-tech-stack {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}

.tech-tag {
  background: #f6ec4f;
  color: #00061a;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  font-family: "Archivo", sans-serif;
}

.product-content {
  padding: 30px;
}

.product-content h3 {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 15px;
  font-family: "Archivo", sans-serif;
}

.product-content p {
  font-size: 16px;
  line-height: 26px;
  color: #fff;
  margin-bottom: 20px;
  font-family: "Open Sans", sans-serif;
}

.product-actions {
  margin-top: 20px;
}

.product-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #f6ec4f;
  color: #00061a;
  padding: 12px 24px;
  border-radius: 25px;
  text-decoration: none;
  font-weight: 600;
  font-family: "Archivo", sans-serif;
  transition: all 0.3s ease;
}

.product-btn:hover {
  background: #fff;
  transform: translateY(-2px);
}

.product-btn i {
  font-size: 16px;
}

/* Responsive Design */
@media only screen and (max-width: 991px) {
  .see__pad {
    padding: 80px 0;
  }
  
  .products-grid {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 25px;
  }
}

@media only screen and (max-width: 767px) {
  .see__pad {
    padding: 60px 0;
  }

  .products-main-title h2 {
    font-size: 36px;
    line-height: 46px;
  }

  .products-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .pattern-9,
  .pattern-10,
  .pattern-11,
  .pattern-12 {
    opacity: 0.05;
  }
}

@media only screen and (max-width: 399px) {
  .see__pad {
    padding: 40px 0;
  }

  .products-main-title h2 {
    font-size: 28px;
    line-height: 38px;
  }

  .products-section-label h4 {
    font-size: 16px;
    letter-spacing: 8px;
  }

  .product-content {
    padding: 20px;
  }

  .product-image {
    height: 150px;
  }
}
</style>
